import Card from 'antd/lib/card'
import './index.less'

export default Card



// WEBPACK FOOTER //
// ./src/elements/card/index.js